import { Injectable } from '@angular/core';
import { AppSaverService } from '@Services/cache/saver.service';
import { ModuleColourService } from '@Services/module-colour.service';
import { EModuleThemeCat, IModuleTheme } from './module-theme-setup.model';
import { Config } from 'projects/evolutics-client-ui/src/app/configs/index.config';
import { environment } from '@environments/environment';
import { AppService } from '@Services/app.service';
import { BehaviorSubject, catchError, map, of } from 'rxjs';
import { ESystem } from '../../models/index.model';

@Injectable({
  providedIn: 'root',
})
export class ModuleThemeSetupService extends AppSaverService {
  private moduleThemes: IModuleTheme[];
  readonly moduleThemes$ = new BehaviorSubject<IModuleTheme[]>([]);
  constructor(
    public mCS: ModuleColourService,
    private appS: AppService,
  ) {
    super('moduleThemes', 'moduleTheme');
    // debugger;
    this.applyModuleTheme();
  }

  /**
   * Apply module themes setup on the web app
   * @param moduleThemes The module themes setup
   */
  applyModuleTheme() {
    this.getFromLocal();
    this.patchColours(this.moduleThemes);
    setTimeout(() => {
      this.mCS.restFuncs
        .searchColourCodes({ queryObject: { refCat: EModuleThemeCat.app, refNo: environment.userName } })
        .pipe(
          catchError((error) => {
            console.warn('Unable to load module theme from gateway', error);
            return of(null);
          }),
        )
        .subscribe((r) => {
          if (!r?.content) return;
          this.saveModuleThemeLocal(r.content);
        });
    }, 1000);
  }

  saveModuleTheme(moduleThemes: IModuleTheme[]) {
    this.saveModuleThemeLocal(moduleThemes);
    return this.mCS.restFuncs.saveColourCode({ body: moduleThemes }).pipe(
      map(() => ({ dbSynced: true })),
      catchError((error) => {
        console.warn('Unable to save module theme to gateway', error);
        return of({ dbSynced: false, error });
      }),
    );
  }

  getModuleThemes() {
    this.getFromLocal();
    return this.moduleThemes || [];
  }

  saveModuleThemeLocal(moduleThemes: IModuleTheme[]) {
    this.moduleThemes = moduleThemes || [];
    this.patchColours(this.moduleThemes);
    this.saveToLocal();
    this.moduleThemes$.next(this.moduleThemes);
  }

  applyPrimaryColourForSystem(system: ESystem) {
    const colourCode = Config.systemMetadataMap.get(system)?.colourCode;
    if (!colourCode) return;
    document.documentElement.style.setProperty('--primary', colourCode);
    document.getElementById('metaThemeColour')?.setAttribute('content', colourCode);
  }

  protected patchColours(moduleThemes: IModuleTheme[]) {
    for (const item of moduleThemes || []) {
      const map = Config.systemMetadataMap.get(item.system);
      if (map) map.colourCode = item.colourCode || map.colourCode;
    }
    this.applyPrimaryColourForSystem(this.appS.system || (environment.currentSystem as ESystem));
  }
}
